export default {
    "You can select up to {count} options": "Puede seleccionar hasta {count} opciones",
    "Please answer all required questions to continue": "Por favor, responda todas las preguntas obligatorias para continuar",
    "Next Section": "Siguiente sección",
    "Previous Section": "Sección anterior",
    "Next Question": "Siguiente pregunta",
    "Previous Question": "Pregunta anterior",
    "Complete": "Finalizar",
    "Please enter all field properly": "Por favor, complete todos los campos correctamente",
    "This question is required": "Esta pregunta es obligatoria",
    "Choose": "Elegir",
    "Other option": "Otra opción",
    "Read more": "Leer más",
    "Show less": "Mostrar menos",
    "Loading": "Cargando",
    "Dashboard": "Dashboard",
    "Buy more answers": "Buy more answers",
    "Per-location QR codes": "Códigos QR por ubicación",
    "Rooms / Tables / Locations": "Habitaciones / Mesas / Ubicaciones",
    "Generate one QR code per location (e.g. hotel rooms 101–150 or restaurant tables). Each QR carries its location, so answers are tagged automatically — the guest never types it. Choose a survey and answer type above first.": "Genere un código QR por ubicación (p. ej. habitaciones 101–150 o mesas de restaurante). Cada QR lleva su ubicación, por lo que las respuestas se etiquetan automáticamente — el huésped nunca la escribe. Elija primero una encuesta y un tipo de respuesta arriba.",
    "Add range": "Añadir rango",
    "Extra locations (comma-separated, e.g. T1, T2, VIP)": "Ubicaciones adicionales (separadas por comas, p. ej. T1, T2, VIP)",
    "QR per page": "QR por página",
    "Label prefix (Room / Table / Σημείο)": "Prefijo de etiqueta (Habitación / Mesa / Ubicación)",
    "Caption (e.g. SCAN TO ANSWER)": "Leyenda (p. ej. SCAN TO ANSWER)",
    "Sheet title (defaults to survey name)": "Título de la hoja (por defecto: nombre de la encuesta)",
    "Generate QR PDF": "Generar PDF QR",
    "locations": "ubicaciones",
    "Please choose a survey": "Elija una encuesta",
    "No locations defined": "No se definieron ubicaciones",
    "Too many locations (max 1000)": "Demasiadas ubicaciones (máx. 1000)",
    "Invalid range (from must be <= to)": "Rango no válido (desde debe ser ≤ hasta)",
    "PDF generated": "PDF generado",
    "QR Code Sheet": "Hoja de códigos QR",
    "Generated": "Generado",
    "Location": "Ubicación",
    "Location (room / table):": "Ubicación (habitación / mesa):",
    "Exact / list (e.g. 205, 210)": "Exacto / lista (p. ej. 205, 210)",
    "Range from": "Rango desde",
    "Range to": "Rango hasta",
    "Guest": "Huésped",
    "Location — exact / list (e.g. 205, 210)": "Ubicación — exacto / lista (p. ej. 205, 210)",
    "Location range from": "Rango de ubicación desde",
    "Location range to": "Rango de ubicación hasta",
    "is": "es",
    "is not": "no es",
    "includes": "incluye",
    "does not include": "no incluye",
    "between": "entre",
    "contains": "contiene",
    "does not contain": "no contiene",
    "on": "el",
    "before": "antes",
    "after": "después",
    "value": "valor",
    "min": "mín",
    "max": "máx",
    "If answer": "Si la respuesta",
    "go to": "ir a",
    "Next question (default)": "Siguiente pregunta (predeterminado)",
    "Add rule": "Añadir regla",
    "Otherwise, go to": "De lo contrario, ir a",
    "Send the respondent to a different question depending on their answer to this question. Rules are checked top to bottom; the first match wins. If nothing matches, the default applies.": "Envía al encuestado a una pregunta diferente según su respuesta a esta pregunta. Las reglas se comprueban de arriba abajo; gana la primera coincidencia. Si ninguna coincide, se aplica la opción predeterminada.",
    "Add this question's answer options first to build branching rules.": "Añade primero las opciones de respuesta de esta pregunta para crear reglas.",
    "Logic / Branching": "Lógica / Ramificación",
    "optional": "opcional",
    "End of survey": "Fin de la encuesta",
    "A question with branching rules is answered before the survey continues.": "Una pregunta con reglas de ramificación se responde antes de que la encuesta continúe.",

    // reports — modern Analytical/Summary labels
    "Overall score": "Puntuación global",
    "Responses": "Respuestas",
    "Positive": "Positivo",
    "positive": "positivo",
    "No answers": "Sin respuestas",

    // reports — Summary period comparison
    "Period 1": "Período 1",
    "Period 2": "Período 2",
    "Compare periods": "Comparar períodos",
    "set Period 2": "establecer período 2",

    // reports — Text reports search/sort
    "No respondents match": "Ningún encuestado coincide con",
    "Search by location, name, email or answer text…": "Buscar por ubicación, nombre, email o texto de respuesta…",
    "Sorted worst score first — the responses that need attention are at the top.": "Ordenado de peor puntuación primero — las respuestas que requieren atención están arriba.",

    // reports — Excel export
    "Excel export is not available for this report": "La exportación a Excel no está disponible para este informe",
    "Choose a report type above to begin": "Elige un tipo de informe arriba para empezar",
    "Filters": "Filtros",
    "Hide filters": "Ocultar filtros",
    "Show results": "Mostrar resultados",
    "Print": "Imprimir",
    "Answer:": "Respuesta:",
    "Choose a report type": "Elige un tipo de informe",
};